function findScrollParent(node) {
  if (node == null) {
    return null
  }

  if (node.scrollHeight > node.clientHeight) {
    return node
  } else {
    if (node.parentNode) {
      return findScrollParent(node.parentNode)
    } else {
      return node
    }
  }
}

export default findScrollParent
